module.exports = __webpack_public_path__ + "img/ico029.126b3012.svg";